import { AssetType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredDate, requiredEnum, requiredString } from '@/utils/zodUtils';

export const EducationDetailsFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      type: requiredEnum(AssetType, t),
      description: z.string().nullable(),
      startDate: requiredDate(t),
      endDate: requiredDate(t),
      value: requiredString(t),
      downPayment: z.string().nullable(),
      scholarship: z.string().nullable(),
    })
    .strict();

export type EducationDetailsFormType = z.infer<ReturnType<typeof EducationDetailsFormSchema>>;
